import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home'
import Create from './pages/Create'

import Dashboard from './pages/Dashboard/Index'
import DashboardTimeline from './pages/Dashboard/Timeline'
import DashboardStats from './pages/Dashboard/Stats'
import DashboardUsers from './pages/Dashboard/Users'
import DashboardPronos from './pages/Dashboard/Pronos'
import DashboardProno from './pages/Dashboard/Prono'
import DashboardRequest from './pages/Dashboard/Request'

import Pronos from './pages/Pronos'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/create',
      name: 'create',
      component: Create
    },
    { path: '/dashboard/:id', component: Dashboard,
      children: [
        {
          path: 'timeline',
          name: 'dashboard-timeline',
          component: DashboardTimeline
        },
        {
          path: 'stats',
          name: 'dashboard-stats',
          component: DashboardStats
        },
        {
          path: 'users',
          name: 'dashboard-users',
          component: DashboardUsers
        },
        {
          path: 'pronos',
          name: 'dashboard-pronos',
          component: DashboardPronos
        },
        {
          path: '',
          redirect: 'timeline'
        }
      ]
    },
    {
      path: '/dashboard/:id/prono',
      name: 'dashboard-prono',
      component: DashboardProno,
    },
    {
      path: '/dashboard/:id/request/:privacy',
      name: 'dashboard-request',
      component: DashboardRequest,
    },
    {
      path: '/pronos',
      name: 'pronos',
      component: Pronos
    },
  ]
})
